import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7qrub4tp9v: FaireBrandEntity = {
  token: "b_7qrub4tp9v",
  type: "brand",
  name: "Konscious Kitchen Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/edc0afa312648069564b5ba725cfee9325df4b1bde8c4325b016da85b8c24cdf.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e79a60f99e7a470c0ebe845a8479e0949ed6062c08d6789a5b623fc0d1986214.png",
  logoUrl:
    "https://cdn.faire.com/fastly/edc0afa312648069564b5ba725cfee9325df4b1bde8c4325b016da85b8c24cdf.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e79a60f99e7a470c0ebe845a8479e0949ed6062c08d6789a5b623fc0d1986214.png",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 250,
  rating: 5,
  reviewCount: 1,
  isInsider: false,
  description:
    "Konsious Kitchen was founded in mid 2019 with an aim of providing clean and healthy food without compromising on taste. It all started when founder Snehal was diagnosed with an autoimmune disorder and was prompted to follow a clean eating lifestyle following her diagnosis.\n\nWhat started as a personal mission soon transformed into something bigger. With a desire to share our discoveries and inspire others, we created a food blog and a YouTube channel, where the KK community began to thrive.\n\nInspired by my mission of healthy eating, my husband Neil joined the cause, bringing his expertise and passion to create the company that Konscious Kitchen has become today. Together, we have built a small, cool family-driven brand with tall ambitions.\n\nWe’re proud to offer a range of products that bring together the best of nutrition and taste.\n\nWhat sets KK apart is our unwavering commitment to quality. Every product is made using MAD CLEAN INGREDIENTS that are mindfully sourced, ensuring they meet the highest standards of cleanliness and purity.\n\nWhen you choose to buy from us, know that you are joining a community of individuals who prioritize their well-being without compromising on taste. Together, let’s savor the joy of clean and mindful eating with Konscious Kitchen\n\nSnehal & Neil - Founders - Konscious Kitchen\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.923Z",
    importedBy: "entity-db-cli",
  },
};
